import { Box, MenuItem } from '@mui/material';
import { CustomTextField, CustomAutoComplete, CustomButton } from '../../../common/components';
import { formatBankName } from '../../bank-movements/utils/formatters';

const ExchangeChecksFilters = ({
  filters,
  onFilterChange,
  bankAccounts = [],
  searchTerm,
  onSearchChange,
  reconciliationFilter,
  onReconciliationChange,
  typeFilter,
  onTypeChange,
  availableMovementTypes = [],
  onExport,
}) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      p: 2,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 2,
      alignItems: 'flex-end',
    }}
  >
    <CustomTextField
      label="Desde"
      type="date"
      value={filters.startDate}
      onChange={(event) => onFilterChange('startDate', event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 180 } }}
    />

    <CustomTextField
      label="Hasta"
      type="date"
      value={filters.endDate}
      onChange={(event) => onFilterChange('endDate', event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 180 } }}
    />

    <CustomAutoComplete
      label="Cuenta"
      value={filters.accountId}
      onChange={(event) => onFilterChange('accountId', event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 260 } }}
    >
      <MenuItem value="">Todas</MenuItem>
      {bankAccounts.map((account) => (
        <MenuItem key={account.uuid} value={account.uuid}>
          {formatBankName(account.bank_name)} - {account.account_number}
        </MenuItem>
      ))}
    </CustomAutoComplete>

    <CustomTextField
      placeholder="Buscar por concepto, comprobante o beneficiario"
      value={searchTerm}
      onChange={(event) => onSearchChange(event.target.value)}
      size="medium"
      sx={{ flex: 1, minWidth: 200 }}
    />

    <CustomAutoComplete
      label="Conciliado"
      value={reconciliationFilter}
      onChange={(event) => onReconciliationChange(event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 150 } }}
    >
      <MenuItem value="all">Todos</MenuItem>
      <MenuItem value="reconciled">Sí</MenuItem>
      <MenuItem value="pending">No</MenuItem>
    </CustomAutoComplete>

    <CustomAutoComplete
      label="Tipo"
      value={typeFilter}
      onChange={(event) => onTypeChange(event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 200 } }}
    >
      <MenuItem value="all">Todos</MenuItem>
      {availableMovementTypes.map((type) => (
        <MenuItem key={type.uuid} value={type.uuid}>
          {type.description}
        </MenuItem>
      ))}
    </CustomAutoComplete>

    <CustomButton variant="base" onClick={onExport}>
      Exportar a Excel
    </CustomButton>
  </Box>
);

export default ExchangeChecksFilters;
